export default "assets/images/logo-cheval-9f7be468.png";